import { Component, OnInit } from '@angular/core';
import { CommonService } from '../_services';
import { Router } from '@angular/router';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-industry-card-view',
  templateUrl: './industry-card-view.component.html',
  styleUrls: ['./industry-card-view.component.css']
})
export class IndustryCardViewComponent implements OnInit {

  route:string;
  cardDetail = [];
  exceedDetail = [];
  industryCardLoader = false;
  countDuration = 1;
  countFrom = 0;
  userData:any = [];
  userName = null;
  vendor_id = 0;
  userLevel = null;

  constructor(private activeroute: ActivatedRoute,private router: Router,
              private _service: CommonService) { }

  ngOnInit() {

    this.userData = JSON.parse(localStorage.getItem('userData'));
    if(this.userData){
      this.userName = this.userData['user_profile_id'];
      this.userLevel = this.userData['access_level'];

      if(this.userLevel == 'vendor'){
        this.vendor_id = this.userData['id'];
      }
    }

    this.getAllIndustryCardDetails();
    this.getAllIndustryCardExceedanceDetails();
  }

  getAllIndustryCardDetails(){

    this.industryCardLoader = true;
    this.route  = 'get-industry-card-details';
    const token    = localStorage.getItem('userToken');
    this.cardDetail = [];
    let data = {};

    if(this.userLevel == 'vendor'){
      data = {'user_id':this.userName,'user_level':this.userLevel, 'vendor_id':this.vendor_id};
    }else {
      data = {'user_id':this.userName,'user_level':this.userLevel};
    }

    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

      if(response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
        // location.reload();
      }
      if(response.status == 200){
        this.cardDetail = response.data;
      }

      this.industryCardLoader = false;
    });
  }

  getAllIndustryCardExceedanceDetails(){

    this.industryCardLoader = true;
    this.exceedDetail = [];
    this.route  = 'get-industry-card-exceedance-details';
    const token    = localStorage.getItem('userToken');
    let data = {};

    if(this.userLevel == 'vendor'){
      data = {'user_id':this.userName,'user_level':this.userLevel, 'vendor_id':this.vendor_id};
    }else {
      data = {'user_id':this.userName,'user_level':this.userLevel};
    }

    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

      this.industryCardLoader = false;

      if(response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
        // location.reload();
      }
      if(response.status == 200){
        this.exceedDetail = response.data;
      }

    });
  }

  redirectCEMS(ind_id) {
    this._service.ind_id = ind_id;
    this.router.navigate(['/cems']);
  }
}
